// ======================================================================
// File Name       : userHistoryCourse
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../constants/actionTypes/userHistoryCourse';

const initialState = {
  courseListData: {},
  courseListSearchInit: {},
  courseList: [],
  courseStatus: {},
  recordNum: 0,
  isExist: true,
  courseDetail: {},
  pieChartData: {},
  barChartData: {},
};

export default function userHistoryCourse(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.USER_HISTORY_COURSE_INIT_SEARCH_INPUT: {
      const { initData } = action;
      return { ...state, courseListSearchInit: initData };
    }
    case ActionTypes.USER_HISTORY_COURSE_RECEIVED_SEARCH_RESULT: {
      const { courseList, courseStatus, recordNum } = action;
      return {
        ...state,
        courseList,
        courseStatus,
        recordNum,
      };
    }
    case ActionTypes.USER_HISTORY_COURSE_RECEIVED_COURSE_DETAIL: {
      const { isExist, courseDetail, userGroupBySecernId } = action;
      return {
        ...state,
        isExist,
        courseDetail,
        userGroupBySecernId,
      };
    }
    // #7386 START
    case ActionTypes.USER_HISTORY_COURSE_RECEIVED_PIE_CHART_DATA: {
      const { data } = action;
      return {
        ...state,
        pieChartData: data,
      };
    }
    case ActionTypes.USER_HISTORY_COURSE_RECEIVED_BAR_CHART_DATA: {
      const { data } = action;
      return {
        ...state,
        barChartData: data,
      };
    }
    // #7386 END

    default:
      return state;
  }
}
